// Checklist item state constants
export const CHECKLIST_ITEM_STATE_INCOMPLETE = 'incomplete';
export const CHECKLIST_ITEM_STATE_ACTIVE = 'active';
export const CHECKLIST_ITEM_STATE_COMPLETE = 'complete';
